import _ from 'lodash';
import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';
import { env } from '~/commons/config';
import { object, string, number } from 'yup';
import useHttpStatus from '~/commons/hooks/useHttpStatus';
import PageHttp from '~/commons/components/PageHttp.jsx';
import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';
import FieldArrayCards from '../FieldArrayCards.jsx';
import FormResource from '../FormResource.jsx';

const defaults = {
  itemCode: '',
  gdn: '',
  status: '',
  orgId: null,
  design: {},
  supplier: {},
  uom: '',
  meta: {},
  remarks: '',
  prices: {
    tradePriceRate: 100,
    unitRetailPrice: 0,
    unitTradePrice: 0,
    retailPrice: 0,
    tradePrice: 0,
    quantity: 0,
    currency: '',
  },
  location: '',
  showroom: '',
};
const schema = object({
  status: string(),
  remarks: string(),
  location: string(),
  showroom: string(),
});

const toFixed2 = (x) => {
  if (_.isNumber(x)) return x.toFixed(2);
  if (_.isString(x)) {
    const num = parseFloat(x);
    return _.isFinite(num) ? num.toFixed(2) : x;
  }
  return x;
}

const FormStock = ({ stock }) => {
  const api = '/api/core/tfy/stocks';

  const [showroomRes, showroomReq] = useHttpStatus();
  React.useEffect(() => {
    showroomReq({ url: '/api/core/users/self/showrooms' });
  }, []);
  return (
    <PageHttp res={showroomRes}>
      {(showrooms) => (
        <FormResource
          {...{
            defaults,
            schema,
            segment: 'stocks',
            stored: stock,
            api,
            onSubmit: (submit) => {
              const v = _.pick(submit, ...[
                'status',
                'remarks',
                'location',
                'showroom',
              ]);
              return {
                ...v,
              };
            },
          }}>
          {({ values }) => (
            <>
              <a
              className="btn btn-secondary mb-3 ml-2"
                href={`/api/core/tfy/stocks/${stock._id}/artwork/${encodeURIComponent(_.compact([
                  stock.design?.design,
                  stock.createdAt?.slice(0, 10).replace(/-/g, ''),
                ]).join(' '))}.pdf`}
              target='_blank' rel="noreferrer"
            >
              <FA icon={faDownload} fixedWidth />
              {' Artwork'}
            </a>
              <Tabs defaultActiveKey="basic" unmountOnExit>
                <Tab eventKey="basic" title="Basic">
                  <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">BASIC</h6>
                  <div className="row">
                    <div className="col">
                      <FormGroup name="itemCode" disabled />
                    </div>
                    <div className="col">
                      <FormGroup name="gdn" disabled />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <FormGroup name="status" as="select">
                        <option value=""> - </option>
                        {(env?.status?.tfyStocks || []).map((v) => (
                          <option value={v} key={v}>
                            {_.startCase(v)}
                          </option>
                        ))}
                      </FormGroup>
                    </div>
                    <div className="col">
                      <FormGroup name="orgId" label="Organization ID" disabled />
                    </div>
                  </div>
                  <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">ADDITIONAL</h6>
                  <div className="row">
                    <div className="col">
                      <FormGroup name="design.brand" label="Brand" disabled />
                    </div>
                    <div className="col">
                      <FormGroup name="design.coll.name" label="Collection" disabled />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <FormGroup name="design.design" label="Design" disabled />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <FormGroup name="remarks" />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <div className="form-group">
                        <label>Preview</label>
                        <img
                          className='w-100'
                          src={`/api/core/tfy/stocks/${stock._id}/preview.svg`}
                          alt={'s'}
                        />
                      </div>
                    </div>
                    <div className="col">
                    </div>
                    <div className="col">
                    </div>
                    <div className="col">
                    </div>
                  </div>
                </Tab>
                <Tab eventKey="measurement" title="Measurement">
                  <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">DIMENSION</h6>
                  <div className="row">
                    <div className="col">
                      <FormGroup name="uom" disabled />
                    </div>
                    <div className="col">
                      <FormGroup name="meta.material" label="Material" disabled />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <div className="form-group">
                        <label>Standard Size</label>
                        <FormCheckGroup name="meta.isStandardSize" type="checkbox" label="" disabled asSwitch />
                      </div>
                    </div>
                    <div className="col">
                      <div className="form-group">
                        <label>Default Color</label>
                        <FormCheckGroup name="meta.isDefaultColor" type="checkbox" label="" disabled asSwitch />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <FormGroup name="meta.unit" label="Unit" disabled />
                    </div>
                    <div className="col">
                      <FormGroup name="meta.shape" label="Shape" disabled />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <label>Carpet Width</label>
                      <input className="form-control" disabled value={toFixed2(_.get(values, 'meta.width'))} />
                    </div>
                    <div className="col">
                      <label>Carpet Length</label>
                      <input className="form-control" disabled value={toFixed2(_.get(values, 'meta.length'))} />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <label>Custom Carpet Width</label>
                      <input className="form-control" disabled value={toFixed2(_.get(values, 'meta.customWidth'))} />
                    </div>
                    <div className="col">
                      <label>Custom Carpet Length</label>
                      <input className="form-control" disabled value={toFixed2(_.get(values, 'meta.customLength'))} />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <label>Shape Left</label>
                      <input className="form-control" disabled value={toFixed2(_.get(values, 'meta.shapeX'))} />
                    </div>
                    <div className="col">
                      <label>Shape Top</label>
                      <input className="form-control" disabled value={toFixed2(_.get(values, 'meta.shapeY'))} />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <label>Shape Width</label>
                      <input className="form-control" disabled value={toFixed2(_.get(values, 'meta.shapeWidth'))} />
                    </div>
                    <div className="col">
                      <label>Shape Length</label>
                      <input className="form-control" disabled value={toFixed2(_.get(values, 'meta.shapeLength'))} />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <label>Actual Width</label>
                      <input className="form-control" disabled value={toFixed2(_.get(values, 'meta.actualWidth'))} />
                    </div>
                    <div className="col">
                      <label>Actual Length</label>
                      <input className="form-control" disabled value={toFixed2(_.get(values, 'meta.actualLength'))} />
                    </div>
                  </div>
                </Tab>
                <Tab eventKey="sales" title="Sales">
                  <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">PRICES</h6>
                  <div className="row">
                    <div className="col">
                      <FormGroup name="prices.retailPrice" label="Retail Price" disabled />
                    </div>
                    <div className="col">
                      <FormGroup name="prices.tradePrice" label="Trade Price" disabled />
                    </div>
                    <div className="col">
                      <FormGroup name="prices.currency" as="select" disabled>
                        <option value=""> - </option>
                        {env.currencies.map(({ code, symbol }) => (
                          <option value={code} key={code}>
                            {`${_.startCase(code)} - ${symbol}`}
                          </option>
                        ))}
                      </FormGroup>
                    </div>
                  </div>
                  <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">SALES</h6>
                  <div className="row">
                    <div className="col">
                      <FormGroup name="location" />
                    </div>
                    <div className="col">
                      <FormGroup
                        name="showroom"
                        label="Showroom Code"
                        as="select">
                        <option value="">-</option>
                        {showrooms.map((v) => (
                          <option value={v._id} key={v._id}>
                            {`${v.orgId} - ${v.showrmCode}`}
                          </option>
                        ))}
                      </FormGroup>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <FormGroup name="supplier.name" label="Supplier" disabled />
                    </div>
                  </div>
                </Tab>
                <Tab eventKey="layers" title="Layers">
                  <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">LAYERS</h6>
                  <FieldArrayCards name="meta.layerInfo" disabled>
                    {(r, i) => (
                      <>
                        <div className="row">
                          <div className="col">
                            <FormGroup name={`meta.layerInfo.${i}.cutting`} label="Cutting" disabled />
                          </div>
                          <div className="col">
                            <FormGroup name={`meta.layerInfo.${i}.material`} label="Material" disabled />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col">
                            <FormGroup name={`meta.layerInfo.${i}.percentage`} label="Percentage" disabled />
                          </div>
                          <div className="col">
                            <FormGroup name={`meta.layerInfo.${i}.color.name`} label="Color" disabled />
                          </div>
                        </div>
                      </>
                    )}
                  </FieldArrayCards>
                </Tab>
              </Tabs>
            </>
          )}
        </FormResource>
      )}
    </PageHttp>
  );
};

export default FormStock;
